import type { ButtonProps } from '@hover/blueprint';
import { Box, Button, Icon } from '@hover/blueprint';
import type { IconProp } from '@hover/icons';
import React, { useRef } from 'react';

import { MIME_TYPES } from 'src/modules/propertyDetails/components/PropertyUploadPhotos/utils';

interface PhotoUploadInputProps extends ButtonProps {
  label: string;
  icon: IconProp;
  onFileChange: (photoUploadFile: File) => void;
}
type HTMLInputEventTarget = HTMLInputElement & EventTarget;

const PhotoUploadInput = ({
  label,
  icon,
  onFileChange,
  ...props
}: PhotoUploadInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const onPhotoUploadInputChange = (
    event: React.FormEvent<HTMLInputElement>,
  ) => {
    const inputTarget = event.target as HTMLInputEventTarget;
    const photoUploadFile = inputTarget.files && inputTarget.files[0];
    if (photoUploadFile) onFileChange(photoUploadFile);
  };

  return (
    <>
      <Button
        {...props}
        onClick={() => {
          inputRef.current?.click();
        }}
        textDecoration="none"
        variant="tertiary"
        width="100%"
      >
        <Box alignItems="center" justifyContent="space-between" width="100%">
          {label}
          <Icon icon={icon} />
        </Box>
      </Button>
      <input
        accept={MIME_TYPES.join(',')}
        onChange={onPhotoUploadInputChange}
        ref={inputRef}
        style={{ display: 'none' }}
        type="file"
      />
    </>
  );
};

export { PhotoUploadInput };
